/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type DocumentStoreType = {
  /**
   * Fichier numérisé sélectionné dans la modale de saisie, transmis à
   * l'assistant (route distincte) pour affichage dans l'aperçu.
   * Conservé en mémoire uniquement (non sérialisable dans l'URL).
   */
  document: File | null;
  setDocument: (document: File | null) => void;
};

const useDocumentStore = create<DocumentStoreType>()(
  devtools((set) => ({
    document: null,
    setDocument: (document) => set({ document }),
  })),
);

export default useDocumentStore;
